<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';
// eslint-disable-next-line no-unused-vars
import liquidfill from 'echarts-liquidfill'

export default {
  name: "LiquidFill",
  components: {Chart},
  props: {
    data: {},
    scope: Array,
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption() {
      let color;
      if (this.data >= this.scope[0]) {
        color = '#E01F28'
      }
      else if (this.data <= this.scope[1]) {
        color = '#E4D225'
      }
      else {
        color = '#5886f0'
      }

      this.option = {
        title: {
          text: '',
          textStyle: {
            fontWeight: 'normal',
            fontSize: 25,
            color: '#fff',
          },
        },
        series: [
          {
            animation:false,
            type: 'liquidFill',
            radius: '55%',
            center: ['38%', '50%'],
            data: [this.data/100, this.data/100, this.data/100], // data个数代表波浪数
            backgroundStyle: {
              borderWidth: 1,
              color: 'rgb(255,0,255,0.1)',
            },
            // 修改波浪颜色
            color:[color], //所有波浪一个颜色
            // color:['yellow','red','pink'], 每个波浪不同颜色，颜色数组长度为对应的波浪个数
            label: {
              normal: {
                show: true,
                // formatter: (0.5 * 100).toFixed(2) + '%',
                textStyle: {
                  fontSize: 16,
                },
              },
            },
            outline: {
              show: false,
            },
          },
          {
            animation:false,
            type: 'pie',
            center: ['38%', '50%'],
            radius: ['60%', '62%'],
            hoverAnimation: false,
            data: [
              {
                name: '',
                value: this.data,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: color,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: color,
                  },
                },
              },
              {
                animation:false,
                //画中间的图标
                name: '',
                value: 4,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: '#ffffff',
                  normal: {
                    color: color,
                    borderColor: color,
                    borderWidth: 5,
                    // borderRadius: '100%'
                  },
                },
                label: {
                  borderRadius: '100%',
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: color,
                  },
                },
              },
              {
                animation:false,
                // 解决圆点过大后续部分显示明显的问题
                name: '',
                value: 1,
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  color: color,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: color,
                  },
                },
              },
              {
                animation:false,
                //画剩余的刻度圆环
                name: '',
                value: 100-this.data,
                itemStyle: {
                  color: '#050038',
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  labelLine: {
                    show: false,
                  },
                  itemStyle: {
                    color: 'rgba(255,255,255,0)',
                  },
                },
              },
            ],
          },
        ],
      }
    },
  },
}
</script>

<style scoped>

</style>
